import type { ReactNode } from 'react'
import type { Tone } from '../../lib/labelMaps'

const toneClasses: Record<Tone, string> = {
    gray: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300',
    blue: 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300',
    green: 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300',
    amber: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-300',
    red: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-300',
    rose: 'bg-rose-100 dark:bg-rose-900/50 text-rose-700 dark:text-rose-300',
    sky: 'bg-sky-100 dark:bg-sky-900/50 text-sky-700 dark:text-sky-300',
    indigo: 'bg-indigo-100 dark:bg-indigo-900/50 text-indigo-700 dark:text-indigo-400',
    violet: 'bg-violet-100 dark:bg-violet-900/50 text-violet-700 dark:text-violet-300',
}

export function Badge({
    tone = 'gray',
    children,
    className = '',
}: {
    tone?: Tone
    children: ReactNode
    className?: string
}) {
    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${toneClasses[tone]} ${className}`}
        >
            {children}
        </span>
    )
}
